import React from 'react'
import { Icon } from '@material-ui/core'
import RodentCriticalReplacedIcon from '../../../../assets/svg/rodent-critical-replaced-icon.svg'

export function CatchReplacedIcon({ size, ...restProps }) {
    return (
        <Icon {...restProps}>
            <img src={RodentCriticalReplacedIcon} width={size} height={size} />
        </Icon>
    )
}
